import { render } from "./NoteOnboarding.vue?vue&type=template&id=57d8a692&scoped=true"
import script from "./NoteOnboarding.vue?vue&type=script&lang=js"
export * from "./NoteOnboarding.vue?vue&type=script&lang=js"

import "./NoteOnboarding.vue?vue&type=style&index=0&id=57d8a692&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d8a692"]])

export default __exports__